import React from 'react'
import './styles.scss'

const Button = React.forwardRef(({ 
  children, 
  variant = 'primary', // 'primary' | 'secondary' | 'outline' | 'ghost'
  size = 'md',        // 'sm' | 'md' | 'lg'
  className = '', 
  fullWidth = false,
  loading = false,
  disabled = false,
  type = 'button',
  icon,
  ...props 
}, ref) => {
  
  // Construct class names manually without classnames library
  const variantClass = `btn-${variant}`
  const sizeClass = `btn-${size}`
  const widthClass = fullWidth ? 'btn-full-width' : ''
  const loadingClass = loading ? 'btn-loading' : ''
  const classes = `custom-btn ${variantClass} ${sizeClass} ${widthClass} ${loadingClass} ${className}`.trim()

  return (
    <button 
      ref={ref}
      type={type}
      className={classes}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? (
        <div className="btn-loader-wrapper">
          <span className="btn-spinner"></span>
          <span className="btn-loading-text">Processing...</span>
        </div>
      ) : (
        <div className="btn-content">
          {icon && <span className="btn-icon">{icon}</span>}
          {children}
        </div>
      )}
    </button>
  )
})

Button.displayName = 'Button'

export default Button
